// extracted by extract-css-chunks-webpack-plugin
module.exports = {"header":"header___cc2Cs","collapseIcon":"collapseIcon___HPh2i"};